import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
import { Star, BadgeCheck, Crown } from 'lucide-react';
interface Testimonial {
  name: string;
  image: string;
  quote: string;
  result: string;
}
export function MarcaPrivadaTestimonials() {
  const testimonials: Testimonial[] = [{
    name: 'Daniel Herrera',
    image: 'https://randomuser.me/api/portraits/men/42.jpg',
    quote: 'Lo que más me gustó fue que explican TODO paso a paso. Nunca había importado productos y ahora ya entiendo cómo hablar con proveedores, validar productos y comenzar una marca real.',
    result: 'Encontró sus primeros proveedores en Alibaba'
  }, {
    name: 'Valentina Cruz',
    image: 'https://randomuser.me/api/portraits/women/44.jpg',
    quote: 'La parte de Inteligencia Artificial me sorprendió muchísimo. Los prompts ayudan demasiado a investigar productos y ahorrar tiempo buscando oportunidades.',
    result: 'Encontró ideas de productos usando IA'
  }, {
    name: 'Andrés Salazar',
    image: 'https://randomuser.me/api/portraits/men/47.jpg',
    quote: 'Había comprado otros cursos antes y este se siente mucho más moderno y práctico. No es teoría aburrida, realmente te enseñan cómo comenzar.',
    result: 'Aprendió a validar productos antes de invertir'
  }, {
    name: 'Camila Moreno',
    image: 'https://randomuser.me/api/portraits/women/49.jpg',
    quote: 'Me gustó que no se enfoca solamente en Amazon. Ahora entiendo cómo vender también en Shopify y TikTok Shop usando productos importados.',
    result: 'Comenzó a crear su propia marca'
  }, {
    name: 'Javier Mendoza',
    image: 'https://randomuser.me/api/portraits/men/52.jpg',
    quote: 'El bono de proveedores verificables tiene muchísimo valor. Aprendí cómo negociar precios y cómo evitar errores que normalmente cuestan dinero.',
    result: 'Aprendió negociación con proveedores'
  }, {
    name: 'Nicole Ramírez',
    image: 'https://randomuser.me/api/portraits/women/55.jpg',
    quote: 'Visualmente el sistema se ve premium y el contenido también. Todo está explicado de forma muy clara y organizada.',
    result: 'Comenzó a investigar productos virales'
  }, {
    name: 'Sebastián Ortega',
    image: 'https://randomuser.me/api/portraits/men/58.jpg',
    quote: 'Antes no entendía cómo funcionaba la importación desde China. Ahora ya sé cómo buscar productos y validar proveedores con más seguridad.',
    result: 'Aprendió a importar desde cero'
  }, {
    name: 'Mariana López',
    image: 'https://randomuser.me/api/portraits/women/61.jpg',
    quote: 'Me encantó que enseñan herramientas reales para investigar tendencias. El módulo de productos virales vale muchísimo.',
    result: 'Encontró oportunidades en TikTok Shop'
  }, {
    name: 'Ricardo Núñez',
    image: 'https://randomuser.me/api/portraits/men/64.jpg',
    quote: 'El sistema completo se siente muy profesional. Me ayudó a entender cómo crear una marca y no solo revender productos.',
    result: 'Comenzó su proyecto de marca privada'
  }, {
    name: 'Alejandra Castillo',
    image: 'https://randomuser.me/api/portraits/women/67.jpg',
    quote: 'La información está súper bien organizada. Incluso alguien sin experiencia puede entender todo paso a paso.',
    result: 'Aprendió Ecommerce desde cero'
  }, {
    name: 'Kevin Torres',
    image: 'https://randomuser.me/api/portraits/men/70.jpg',
    quote: 'Los ejemplos prácticos y las explicaciones de negociación me ayudaron muchísimo. Ahora sé cómo pedir cotizaciones correctamente.',
    result: 'Aprendió a negociar con proveedores'
  }, {
    name: 'Laura Méndez',
    image: 'https://randomuser.me/api/portraits/women/73.jpg',
    quote: 'Lo mejor es que enseñan cómo usar IA para acelerar el proceso. Eso hace que el sistema se sienta mucho más actualizado.',
    result: 'Utilizó IA para validar productos'
  }];
  return <section className="bg-brand-beige py-20 md:py-28 px-5 sm:px-6 relative overflow-hidden" data-id="element-406">
      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-407">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/8 rounded-full blur-3xl" data-id="element-408"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-brand-green/8 rounded-full blur-3xl" data-id="element-409"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-410">
        {/* Header */}
        <FadeIn data-id="element-411">
          <div className="text-center mb-14 md:mb-20 max-w-3xl mx-auto" data-id="element-412">
            <div className="inline-flex items-center justify-center gap-2 bg-brand-green text-white border border-brand-gold/40 rounded-full px-5 py-2.5 mb-6 shadow-lg" data-id="element-413">
              <Crown className="w-4 h-4 text-brand-gold" data-id="element-414" />
              <span className="text-[11px] sm:text-xs font-bold tracking-[0.18em] uppercase text-brand-gold" data-id="element-415">
                Testimonios — Sistema de Marca Privada™
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold text-brand-green leading-[1.1] tracking-tight mb-5" data-id="element-416">
              Resultados de personas reales
            </h2>
            <p className="text-base md:text-lg text-brand-text/70 leading-relaxed" data-id="element-417">
              Personas que decidieron aprender Ecommerce, importar desde China y
              comenzar a construir su propia marca.
            </p>

            {/* Aggregate rating */}
            <div className="inline-flex items-center gap-3 mt-7 bg-white border border-brand-gold/20 rounded-full px-5 py-2.5 shadow-sm" data-id="element-418">
              <div className="flex gap-0.5" data-id="element-419">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-420" />)}
              </div>
              <span className="text-sm font-semibold text-brand-green" data-id="element-421">
                4.9 / 5 — basado en estudiantes reales
              </span>
            </div>
          </div>
        </FadeIn>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-422">
          {testimonials.map((t, index) => <FadeIn key={index} delay={0.04 * (index % 6)} data-id="element-423">
              <article className="group h-full bg-white rounded-2xl border border-brand-text/8 shadow-[0_4px_24px_-12px_rgba(0,0,0,0.1)] hover:shadow-[0_20px_45px_-15px_rgba(28,57,40,0.18)] hover:-translate-y-1 hover:border-brand-gold/30 transition-all duration-300 p-6 md:p-7 flex flex-col" data-id="element-424">
                {/* Top: Avatar + Name + Stars */}
                <div className="flex items-start gap-4 mb-5" data-id="element-425">
                  <div className="relative flex-shrink-0" data-id="element-426">
                    <img src={t.image} alt={t.name} loading="lazy" className="w-14 h-14 rounded-full object-cover ring-2 ring-brand-gold/20 shadow-md" data-id="element-427" />
                    <span className="absolute -bottom-1 -right-1 w-5 h-5 bg-brand-green rounded-full border-2 border-white flex items-center justify-center shadow-sm" data-id="element-428">
                      <BadgeCheck className="w-3 h-3 text-brand-gold" strokeWidth={2.5} data-id="element-429" />
                    </span>
                  </div>
                  <div className="min-w-0 flex-1" data-id="element-430">
                    <p className="font-bold text-brand-green leading-tight truncate text-[15px]" data-id="element-431">
                      {t.name}
                    </p>
                    <div className="flex gap-0.5 mt-1" data-id="element-432">
                      {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-433" />)}
                    </div>
                    <p className="text-[10px] text-brand-text/50 mt-1 uppercase tracking-wider font-semibold" data-id="element-434">
                      Cliente verificado
                    </p>
                  </div>
                </div>

                {/* Quote */}
                <p className="text-sm md:text-[15px] text-brand-text/80 leading-relaxed mb-6 flex-1 italic" data-id="element-435">
                  "{t.quote}"
                </p>

                {/* Result chip */}
                <div className="mt-auto pt-4 border-t border-brand-text/8" data-id="element-436">
                  <div className="flex items-start gap-2.5" data-id="element-437">
                    <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-brand-green flex-shrink-0 mt-0.5 shadow-sm" data-id="element-438">
                      <BadgeCheck className="w-3 h-3 text-brand-gold" strokeWidth={2.5} data-id="element-439" />
                    </span>
                    <span className="text-[12px] sm:text-[13px] font-semibold text-brand-green leading-snug" data-id="element-440">
                      {t.result}
                    </span>
                  </div>
                </div>
              </article>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}